module.exports = __webpack_public_path__ + "img/transactionlogo.6698548a.png";